import React, { useCallback } from 'react';
import classnames from 'classnames';
import Checkbox from 'monday-ui-react-core/dist/Checkbox';
import './document-signature-component.scss';

export default function DocumentSignatureComponent({ id, withSignature, onTemplateDataChange, data, previewMode }) {
  const isSignatureChecked = data?.withSignature;

  const onAddSignatureChange = useCallback(
    (e) => {
      onTemplateDataChange(id, { ...data, withSignature: e.target.checked });
    },
    [id, data]
  );

  const renderSignatureSections = () => (
    <div className="signature-sections">
      <div className="row pdf-row">
        <div className="field">Signature</div>
        <div className="field">Date</div>
      </div>
      <div className="row pdf-row">
        <div className="field">Name</div>
      </div>
    </div>
  );

  const renderContent = () => {
    if (!previewMode) {
      return <Checkbox checked={isSignatureChecked} label="Add signature" onChange={onAddSignatureChange} />;
    }
    if (isSignatureChecked) {
      return renderSignatureSections();
    }

    return <></>;
  };

  return <div className={classnames('document-signature-component', { preview: previewMode })}>{renderContent()}</div>;
}
